import { assertEvent } from 'xstate5';

import { type ScrollspyVirtualizedGuard } from '../scrollspy-virtualized.types';

// ─────────────────────────────────────────────────────────────────────────────

const checkIfNoPendingTarget: ScrollspyVirtualizedGuard = ({ context }) => {
  return context.pendingTargetId === undefined;
};

const checkIfPendingTargetReached: ScrollspyVirtualizedGuard = ({ context, event }) => {
  assertEvent(event, 'SET_VISIBLE_TARGETS');

  const { pendingTargetId } = context;

  if (pendingTargetId === undefined) {
    return false;
  }

  return event.targetIds.includes(pendingTargetId);
};

const checkIfVisibleTargetChanged: ScrollspyVirtualizedGuard = ({ context, event }) => {
  assertEvent(event, 'SET_VISIBLE_TARGETS');

  const [visibleTargetId] = event.targetIds;

  if (visibleTargetId === undefined) {
    return false;
  }

  return visibleTargetId !== context.activeTargetId;
};

// ─────────────────────────────────────────────────────────────────────────────

export const Guards = {
  checkIfNoPendingTarget,
  checkIfPendingTargetReached,
  checkIfVisibleTargetChanged,
};
